module.exports = __webpack_public_path__ + "static/media/file7.206bc2ad.jpg";